import React from "react";
import Page from "../models/Page";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { PagePrintInfo } from "../models/PagePrintInfo";
import MemoView from "./MemoView";
import { RDiv } from "../components/renderPrimitives/RDiv";

export default function MemosView(props: { mainPage: Page; page: Page; print?: PagePrintInfo }) {
  const { mainPage, page, print } = props;

  useOnChangeWatcher(page.memos);

  const children: any = [];
  page.memos.forEach((memo) => {
    if (memo.className == "Memo") {
      children.push(<MemoView key={memo.id} memo={memo} page={page} mainPage={mainPage} print={print} />);
    }
  });

  return (
    <RDiv
      style={{
        position: "absolute",
        left: "0px",
        top: "0px",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      {children}
    </RDiv>
  );
}
